module.exports = __webpack_public_path__ + "static/media/ios-badge@2x.46b17ff1.png";